(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/no-syndicate-prolongation.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/no-syndicate-prolongation.js');

'use strict';

function noSyndicateProlongation(_ref) {
  let {
    next
  } = _ref;
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    allowDimmerClick: true,
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Hoppsan!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du vill förlänga ett lagspel där du inte längre är medlem. Vi ändrar så du betalar från ditt eget spelkonto.'
    }],
    actions: [{
      title: 'OK',
      callback: (e, forms, dialog) => {
        dialog.close();
        next();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
}
svs.numbergames.pay_numbergames.noSyndicateProlongation = noSyndicateProlongation;

 })(window);